module.exports = __webpack_public_path__ + "img/IT0000176947615.7c21b23f.png";